import React from 'react';
import { useLoadMemberships } from 'hooks/useAuth';
import AppShell from './layout/AppShell';

/**
 * Layout route for all /console/* pages.
 * Renders AppShell which injects child routes via <Outlet />, and loads the
 * user's tenant list.
 */
export default function ConsolePage() {
  useLoadMemberships();
  return <AppShell />;
}
